/* eslint-disable react/no-array-index-key */
import React, { useCallback  } from 'react';
import { Container, Modal } from './styles';
import { Button } from 'reactstrap';
import axios from 'axios'

import fileDownload from 'js-file-download';

function PDFModal({ closeModal,pdfUrl, title}) {
	const handleDownload = useCallback(()=>{
		const url = process.env.REACT_APP_GEOWISE_HOST + pdfUrl
		const filename = url.substring(url.lastIndexOf("/") + 1).split("?")[0]
		
		axios.get(url,{
			responseType: 'blob'
		})
		.then(res=>{
			fileDownload(res.data, filename)
		})		
		// const link = document.createElement('a')
		// link.href =url
		// link.setAttribute('download',filename)
		// link.setAttribute('target','_blank')
		// document.body.appendChild(link)
		// link.click();
		// link.parentNode.removeChild(link);
	},[pdfUrl])

	return (
		<Container>
			<Modal>
				<div className='report-header-container'>
					<h4 className='header-title m-0'>{title}</h4>
					<div className='report-header-actions-container'>
						<Button
							type="button"
							className="mx-1 w-100"
							size="sm"
							color="success"
							onClick={handleDownload}
						>
							Download
						</Button>
						<Button
							type="button"
							className="mx-1 w-100"
							onClick={closeModal}
							size="sm"
							color="danger"
						>
							Fechar
						</Button>						
					</div>
				</div>
				<hr />
				<iframe title="documento" id="pdfframe" src={process.env.REACT_APP_GEOWISE_HOST + pdfUrl} frameborder="0"></iframe>
			</Modal>
		</Container>
	);
}

export default PDFModal;
